import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Context as AuthContext } from '../Redux/context/AuthContext';

const PrivateUserJourneyRoutes = ({ component: Component, ...rest }) => {
  const { state } = React.useContext(AuthContext);
  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;

  return (
    <Route
      {...rest}
      render={(props) =>
        loginData?.userJourneyCompleted || loginData?.isAdmin ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default React.memo(PrivateUserJourneyRoutes);
